import { useAuth } from "../helpers/Auth";
import useFirebaseData from "./useFirebaseData";
import type { Preferences } from "../types";

const useFirebasePreferences = () => {
  const { authUID } = useAuth();
  return useFirebaseData<Preferences>(authUID ? `/userdata/${authUID}/preferences` : null);
};

export default useFirebasePreferences;
